import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useApp } from '../contexts/AppContext';
import AuthControls from '../components/AuthControls';
import usePageTitle from '../hooks/usePageTitle';
import routeForUser, { HOME_ROUTE } from '../auth/routeForUser';

function HomePage() {
  usePageTitle('Home');

  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useApp();

  // The same rule the login page applies: signed out goes to login, and an
  // account with no organization goes to registration. Guarding on sign-in
  // alone left a new chapter owner on an empty page.
  const destination = loading
    ? HOME_ROUTE
    : routeForUser({ isAuthenticated, user });

  useEffect(() => {
    if (destination !== HOME_ROUTE) {
      navigate(destination, { replace: true });
    }
  }, [destination, navigate]);

  // Show loading while auth state is being determined
  if (loading) {
    return <div>Loading...</div>;
  }

  if (destination !== HOME_ROUTE) {
    return null;
  }

  return (
    <div>
      <AuthControls />
      <h1>One Stop Greek</h1>
    </div>
  );
}

export default HomePage;
